import { useState } from "react";
import { m } from "@/paraglide/messages";
import { DrawSignature } from "./DrawSignature";
import { TypeSignature } from "./TypeSignature";

export type SignatureMode = "draw" | "type";

function tabClass(active: boolean) {
  return `rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
    active
      ? "bg-primary text-primary-foreground"
      : "text-muted-foreground hover:text-foreground"
  }`;
}

/** Mode switcher wrapping the draw and type signature tools. */
export function SignatureMaker({
  defaultMode = "draw",
}: {
  defaultMode?: SignatureMode;
}) {
  const [mode, setMode] = useState<SignatureMode>(defaultMode);
  return (
    <div className="rounded-2xl border border-border bg-card/60 p-6 sm:p-8">
      <div
        role="tablist"
        aria-label={m.sig_tool_name()}
        className="mb-6 inline-flex gap-1 rounded-lg border border-border p-1"
      >
        <button
          type="button"
          role="tab"
          aria-selected={mode === "draw"}
          onClick={() => setMode("draw")}
          className={tabClass(mode === "draw")}
        >
          {m.sig_mode_draw()}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={mode === "type"}
          onClick={() => setMode("type")}
          className={tabClass(mode === "type")}
        >
          {m.sig_mode_type()}
        </button>
      </div>
      {mode === "draw" ? <DrawSignature /> : <TypeSignature />}
    </div>
  );
}
